<template>
  <div>
    <div class="footer">
      <div>
        <span>主管部门:濮阳市农业农村局</span>
        <span>监管部门:濮阳市纪委监委</span>
        <span>管理单位:濮阳市农村集体"三资"服务办公室</span>
        <span>技术单位:河南晟宇信息技术有限公司</span>
        <span
          >友情链接:
          <a
            style="color: #407fff; text-decoration: underline"
            href="http://www.pyjjw.gov.cn/hualong/"
            target="_blank"
            >濮阳市纪委监委</a
          >&nbsp;
          <a
            style="color: #407fff; text-decoration: underline"
            href=""
            target="_blank"
            >濮阳市农业农村局</a
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
}
</script>

<style scoped>
.footer {
  height: 200px;
  width: 100%;
  //background: url("../assets/img/footer.png") no-repeat;
  background-color: rgba(0, 0, 0, 0.4);
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer > div {
  display: flex;
  flex-direction: column;
}
.footer > div > span {
  color: #000;
  color: #fff;
  font-family: Source Han Sans;
  opacity: 1;
  font-size: 26px;
  font-weight: normal;
  line-height: 30px;
  letter-spacing: 0em;
  margin-bottom: 10px;
}
</style>
